import React, { useEffect, useState } from "react";
import { Field, FormikProvider, Form, useFormik } from "formik";
import Menubar from "../Menubar";
import { store } from "../../App";
import MasterService from "../../Services/MasterService";
import { AiFillFileExcel, AiOutlineSearch } from "react-icons/ai";
import { Container, Row, Col, Button, Modal, Tab, Nav } from "react-bootstrap";
import { MdOutlinePictureAsPdf } from "react-icons/md";
import { allowNumberswithMaxLengthcatidtypeOnly, allowNumberswithMaxLengthtypeOnly, convertFormattedToPlainNumber, exportToentryExcel, formatNumberIndianWithDecimal, generateentryPdf, isValidthreee } from "../utils/commonFunctions";
import KpiService from "../../Services/KpiService";
import { FaExclamationTriangle, FaRegSave } from "react-icons/fa";
import AlertModal from "../Alert/AlertModal";
import { Alert } from "@mui/material"
import useAlert from "../Alert/useAlert";
import { Link } from "@mui/material";
import { IoIosReturnLeft } from "react-icons/io";
export default function SectariatwiseTargetentry() {
  const { showAlert, alertData, showAlertMessage, closeAlert } = useAlert();
  const [buttontype, setButtontype] = useState("");
  const [distEnb, setDistEnb] = useState(false);
  const [distlist, setDistrictList] = useState();
  const [mandallist, setMandalList] = useState();
  const [EntryData, setEntrydata] = useState();
  const [Entryenb, setEntryEnb] = useState();
  const [alertShownIndexes, setAlertShownIndexes] = useState([]);
  const [showModal, setshowModal] = useState(false);
  const [disablee, setdisablee] = useState(false);
  const [buttonenb, setbuttonenb] = useState(true);
  const [container, setContainer] = useState(false);
  const [Yearlist, setYearlist] = useState();
  let username = localStorage.getItem("username");
  let roleid = localStorage.getItem("role");
  let district = localStorage.getItem("districtid");
  let mandal = localStorage.getItem("mandalid");
  let deptName = localStorage.getItem("deptName");
  let deptId = localStorage.getItem("sec_dept_id");
     const restrictToPasteOnlyEightDotThreeAllowKeyPress = (formik, fieldName, index) => ({
  onPaste: (e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData("text").trim();
 
    const regex = /^\d{1,8}(\.\d{1,3})?$/;
 
    if (regex.test(pasted)) {
      formik.setFieldValue(`Indicators[${index}].${fieldName}`, pasted);
    } else {
      showAlertMessage("Only numbers up to 8 digits before and 3 after decimal allowed ","warning");
    }
  },
});
  const restrictToPasteOnlyEightDotcommaThreeAllowKeyPress = (formik, fieldName, index) => ({
    onPaste: (e) => {
      e.preventDefault();
      const pasted = e.clipboardData.getData("text").trim();
      const pastedClean = pasted.replace(/,/g, "");
  
      const regex = /^\d{1,8}(\.\d{1,3})?$/;
  
      if (regex.test(pastedClean)) {
         const formatted = formatNumberIndianWithDecimal(pastedClean);
          formik.setFieldValue(`Indicators[${index}].${fieldName}`, formatted);
      } else {
        showAlertMessage("Only numbers with up to 8 digits before the decimal point and up to 3 digits after the decimal point are allowed.","warning");
      }
    },
  });
  const [indicatorhodlist, setindicatorhodlist] = useState([]);
  const formik = useFormik({
    initialValues: {
      userId: "",
      department_id: "",
      district_id: "",
      mandal_id: "",
      f_year: "",
      Indicators: [{ indicator_id: "", entry_value: "", unit: "", indicator_name: "", unit_name: "", numerator: "", denominator: "", no_of_columns: "", multiplir: "", devider: "",status_id:"",ind_type:"" }],
      forward: "",
      forward_to: "",
      role_id: "",
    },
    onSubmit: (values) => {},
  });
const handleInputChange = (e, index) => { const value = e.target.value.trim(); let sanitizedValue = ''; for (let i = 0; i < value.length; i++) { const char = value[i]; if (char !== ',' && char !== '.') { sanitizedValue += char; } } const numericValue = parseFloat(sanitizedValue); if (value && !isNaN(numericValue) && numericValue === 0) { showAlertMessage( "Please Enter if only the Indicator is present at your area!", "warning", () => { formik.setFieldValue(`Indicators[${index}].entry_value`, ""); } ); } };
 
  const [Deptlist, setDeptlist] = useState([]);

  const denominatorchange = (e, index, Indicators) => {
    if (e.target.value === "0") {
      showAlertMessage("0 is not allowed!", "warning", () => {
        formik.setFieldValue(`${Indicators}[${index}].denominator`, "");
      });
    }
  };
  useEffect(() => {
     MasterService.getfinTargetyears().then((finachievres) => {
      if (finachievres.data) {
         let options = finachievres.data.map((item, i) => {
            return ( <option key={i} value={item.id}> {item.value} </option> );
          });
           setYearlist(options);
        }
      });
    if (roleid === "8") {
      let paramss = { userId: username };
      KpiService.getsecretariatlist(paramss).then((res) => {
        if (res.data) {
          let options = res.data?.SDESC.map((item, i) => {
            return (
              <option key={i} value={item.dept_id}>
                {item.dept_name}
              </option>
            );
          });
          setDeptlist(options);
        }
      });
    }
    if (roleid !== "8") {
 formik.setFieldValue("department_id", deptId);

      MasterService.getDistricts().then((res17) => {
        if (res17.data) {
          let options = res17.data.map((item, i) => {
            return (
              <option key={i} value={item.id}>
                {item.value}
              </option>
            );
          });
          setDistrictList(options);
        }
      });

      // let params2 = { type: "get", userId: username, buttonType: "Sec", deptId: roleid === "8" ? formik.values.department_id : deptId, districtId: "0", mandalId: "0", statusId: "1", headId: "0", year: "", remarks: "", roleId: "0", periodicityId: "0", indicaterEntryDto: [] };
      // fetchdata(params2);
    }
  }, []);

  const indicatorData = (val) => {
    
 formik.setFieldValue("Indicators", []);
 setindicatorhodlist([]);
    setEntrydata([]);
    setEntryEnb(false);
    if (!val) {
      return;
    }
     let params2 = { type: "get", userId: username, buttonType: "Sec",
       deptId: formik.values.department_id, districtId: "0", mandalId: "0", year: val,  };
             fetchdata(params2);
   
  };

  const MandalDropdown = (val) => {
    setEntryEnb(false);
    formik.setFieldValue("district_id", "");
    if (!val) {
      return;
    }
    let params = { districtId: val };
    MasterService.getMandals(params).then((res) => {
      if (res.data) {
        let options = res.data.map((item, i) => {
          return (
            <option key={i} value={item.id}>
              {item.value}
            </option>
          );
        });
        setMandalList(options);
      }
    });
  };
  const [updateenb, setupdateenb] = useState();
  const [seqid, setseqid] = useState();
const [maxLen, setMaxlen] = useState();
  const SaveEntryData = (type) => {
    if(!formik.values.f_year)
  { showAlertMessage("Please Select Year", "warning"); return;}
    const val = validatevalue();

    if (!val) {
      showAlertMessage("At least one entry value must be provided.", "warning");
      return;
    }
    store.dispatch({ type: "SHOW_SPINNER" });

    let params = {
      type: "save",
      userId: username,
      deptId: roleid === "8" ? formik.values.department_id : deptId,

      entryType: "sec_level",
      districtId: "SE00",
      sequenceId: seqid,
      mandalId: "0",
      year: formik.values.f_year,
    
    };
    params.indicaterEntryDto = formik.values.Indicators?.map((item, index) => ((item.entry_value&& !(item.status_id === 4)) ? { indicator_id: item.indicator_id, unit: item.unit, 
      targets_2025: item.unit_cat_id === 13 ? item.entry_value: convertFormattedToPlainNumber(item.entry_value), statusId:item.status_id } : null)).filter(Boolean);

    KpiService.SectSaveTargetEntrylist(params)
      .then((res) => {
        setupdateenb(true);
        if (res.data.SCODE === "01") {
          showAlertMessage(res.data.SDESC, "success", () => {
            console.log("mandal save", formik.values.mandal_id);
            let params2 = { type: "get", userId: username, buttonType: "Sec", deptId: roleid === "8" ? formik.values.department_id : deptId, districtId: "0", mandalId: "0",  year: formik.values.f_year };
            fetchdata(params2);
          });

          //           KpiService.SaveTargetEntrylist(paramss)
          //           .then((res) => {
          //             if (res.data.SCODE === "01") {
          //               const isDisabled = res.data.dataList[0].status_id === 4;
          //               setdisablee(isDisabled);
          // setbuttonenb(!isDisabled);

          //               // res.data.dataList[0].status_id===4?setdisablee(true),setbuttonenb(false):setdisablee(false),setbuttonenb(true)
          //               setseqid( res.data.dataList[0].sequence_id);
          //               res.data.dataList.forEach((item) => {
          //                 const index = formik.values.Indicators.findIndex(ind => ind.indicator_id.toString() === item.indicator_id);
          //                 if (index !== -1) {
          //                   formik.setFieldValue(`Indicators[${index}].entry_value`, item.targets_2025);
          //                 }

          //               });

          //             }})
        } else {
          showAlertMessage(res.data.SDESC, "warning", () => {
            setdisablee(false);
            setbuttonenb(true);
            // formik.values.Indicators.map((item,i)=>{ formik.setFieldValue(`Indicators[${i}].entry_value`,"") })
          });
        }
      })
      .catch((err) => {
        showAlertMessage("Failed to save data. Please try again.", "warning");
      })
      .finally(() => {
        store.dispatch({ type: "HIDE_SPINNER" });
      });
  };

  const validatevalue = () => {
    let val = false;
    formik.values.Indicators.map((item, index) => {
      if (item.entry_value) {
        val = true;
      }
    });
    return val;
  };

  const updateData = () => {
    const val = validatevalue();
    if (!val) {
      showAlertMessage("At least one entry value must be provided.", "warning");
      return;
    }
    setshowModal(true);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === "Escape") {
      e.preventDefault();
      e.stopPropagation();
    }
  };
  const handleConfirm = () => {
    if(!formik.values.f_year)
  { showAlertMessage("Please Select Year", "warning"); return;}
    // if(seqid === ""){
    //   showAlertMessage("Please Save Before Submit!","warning");
    //   setshowModal(false);
    //   return;
    // }
    // ((roleid === "60" || roleid === "5") ? "hod_level" : "cpo_level")
    let params = { type: "update", userId: username, entryType: "sec_level", deptId: roleid === "8" ? formik.values.department_id : deptId, districtId: "SE00", mandalId: "0", sequenceId: seqid, year: formik.values.f_year };

    // params.indicaterEntryDto = formik.values.Indicators?.map((item, index) => (item.entry_value ? { indicator_id: item.indicator_id, unit: item.unit, targets_2025: item.entry_value } : null)).filter(Boolean);
let allFieldsFilled = true;

params.indicaterEntryDto = formik.values.Indicators?.map((item) => {
  const value = item.entry_value;

  if (value === "" || value == null) {
      allFieldsFilled = false;
      return null;
    }

    
    if (item.status_id === 4) {
      return null;
    }

  return {
    indicator_id: item.indicator_id,
    unit: item.unit,
    targets_2025:item.unit_cat_id === 13 ? value:convertFormattedToPlainNumber(value)
  };
})
  .filter((entry) => entry !== null);

if (!allFieldsFilled) {
  setshowModal(false);
  showAlertMessage("Please Enter All Indicator's Target values before Submit & Freeze", "warning");
  return;
}
    store.dispatch({ type: "SHOW_SPINNER" });
    KpiService.SectSaveTargetEntrylist(params)
      .then((res) => {
        setshowModal(false);
        setupdateenb(true);
        if (res.data.SCODE === "01") {
          showAlertMessage(res.data.SDESC, "success", () => {
            let params1 = { type: "get", userId: username, deptId: roleid === "8" ? formik.values.department_id : deptId, buttonType: "Sec", mandalId: roleid === "60" || roleid === "5" ? "0" : formik.values.mandal_id, year: formik.values.f_year };
            fetchdata(params1);
          });
        } else {
          showAlertMessage(res.data.SDESC, "warning", () => {
            setdisablee(false);
            setbuttonenb(true);
            // formik.values.Indicators.map((item,i)=>{ formik.setFieldValue(`Indicators[${i}].entry_value`,"") })
          });
        }
      })
      .catch((err) => {
        showAlertMessage("Failed to save data. Please try again.", "warning");
      })
      .finally(() => {
        store.dispatch({ type: "HIDE_SPINNER" });
      });
  };
  const handleClose = () => {
    setshowModal(false);
  };
  const TableData = (val) => {
    if (!val) {
      return;
    }
    console.log("district_id", val);
    let paramss = {
      type: "get",
      userId: username,
      ...(roleid === "60" || roleid === "5" ? { buttonType: "District" } : {}),
      deptId: deptId,
      districtId: roleid === "32" || roleid === "2" ? district : roleid === "60" || roleid === "5" ? val : formik.values.district_id,
      mandalId: roleid === "60" || roleid === "5" ? "0" : val,
      statusId: "1",
      headId: "0",
      year: "",
      remarks: "",
      roleId: "0",
      periodicityId: "0",
      indicaterEntryDto: [],
    };
    fetchdata(paramss);
  };

  const fetchdata = (paramss) => {
    setseqid(null);
   setContainer(false);

    formik.values.Indicators.map((item, i) => {
      formik.setFieldValue(`Indicators[${i}].entry_value`, "");
    });
    KpiService.SectSaveTargetEntrylist(paramss).then((res) => {
      setEntryEnb(true);
      //   if (res.data.SCODE === "01") {
      //     const isDisabled = res.data.dataList[0]?.status_id === 4;
      //     setdisablee(isDisabled); setbuttonenb(!isDisabled); setseqid( res.data.dataList[0].sequence_id);
      //     {res.data.dataList[0].sequence_id ? setupdateenb(true) : setupdateenb(false)}
      //     // res.data.dataList.forEach((item,i)=>{ const index = formik.values.Indicators.findIndex(ind => ind.indicator_id.toString() === item.indicator_id); if (index !== -1) { formik.setFieldValue(`Indicators[${index}].entry_value`, item.targets_2025 ? item.targets_2025 : ""); } })
      //   const matchedIndices = new Set();

      // res.data.dataList.forEach((item, i) => {
      //   const index = formik.values.Indicators.findIndex(ind => ind.indicator_id.toString() === item.indicator_id);
      //   if (index !== -1) {
      //     formik.setFieldValue(`Indicators[${index}].entry_value`, item.targets_2025 ? item.targets_2025 : "");
      //     matchedIndices.add(index);
      //   }
      // });

      // formik.values.Indicators.forEach((_, idx) => {
      //   if (!matchedIndices.has(idx)) {
      //     formik.setFieldValue(`Indicators[${idx}].entry_value`, "");
      //   }
      // });
      //   }
      if (res.data.SCODE === "01") {
        if (res.data.SCODE === "01") {
          const responseList = res.data.dataList || [];
          const isDisabled = responseList[0]?.status_id === 4;
setMaxlen(res.data.dataList[0].max_length)
          setdisablee(isDisabled);
          setbuttonenb(!isDisabled);

          // Only use responseList to set Indicators
          const uniqueIndicatorsMap = {};

          responseList.forEach((item) => {
            const { indicator_id, indicator_name, unit, unit_id, unit_cat_id,targets_2025,status_id,ind_type } = item;
            if (!indicator_id || uniqueIndicatorsMap[indicator_id]) return;

            uniqueIndicatorsMap[indicator_id] = {
              indicator_id: parseInt(indicator_id),
              indicator_name,
              unit_name: unit,
              unit: unit_id,
               unit_cat_id: unit_cat_id,
              entry_value: targets_2025 ?? "",
              status_id: status_id,
           ind_type:ind_type
            };
          });
          // responseList.forEach((item, i) => {
          //   if (item.status_id !== null) {
          //     setseqid(item.sequence_id);
             
          //   }
          // });
         
         let hasStatus4 = false;               // if any indicator has status 4
let hasNWith4 = false;             // if any N-type indicator has status != 4
let hasNew = false; 
let hasNWith0 = false; 
responseList.forEach((item) => {
 if(item.status_id !== null){
  setseqid(item.sequence_id);
 }
  if (item.status_id === 4) {
    hasStatus4 = true; 
   
  }
  if (item.ind_type === "N" && item.status_id === 4) {
    hasNWith4 = true;  
  }
  if (item.ind_type === "N"){hasNew = true}
   if (item.ind_type === "N" && item.status_id !== 4) {
    hasNWith0 = true;  
  }
});
if (hasNWith0 && hasNew) {

  setbuttonenb(true);

}
else 
  if ((hasStatus4 && hasNWith4)|| (hasStatus4 && !hasNew)) {
 
  setbuttonenb(false);
} 
// else if (hasStatus4 && !hasNWith4) {

//   setbuttonenb(true);

// }

else {

  setbuttonenb(true);

}  

          const indicatorsArray = Object.values(uniqueIndicatorsMap);
          setindicatorhodlist(indicatorsArray);
          formik.setFieldValue("Indicators", indicatorsArray);
        }
      } else {
        // showAlertMessage(res.data.SDESC, "warning", ()=>{
        setdisablee(false);
        setbuttonenb(true);
        setseqid("");
        setupdateenb(false);setContainer(true);
        formik.values.Indicators.map((item, i) => {
          formik.setFieldValue(`Indicators[${i}].entry_value`, "");
          // })
        });
      }
    });
  };

  return (
    <>
      <Menubar />

      <Container fluid style={{width:"95%"}} className="map-header">
        <div className="sa-title">
          <h2>
            Secretariat wise <span> Targets Entry</span>
          </h2>
        </div>
      </Container>

      <Container fluid style={{width:"95%"}} className="mt-3 outer-page-content-container">
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            <div className="mandal-container p-4">
              <Row>
                <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className="district-select">
                  <label className="mb-1 fw-bold">Secretariat Name</label>

                  {roleid === "8" ? (
                    <Field
                      component="select"
                      name="department_id"
                      className="mb-3 form-control"
                      onChange={(e) => {
                        // indicatorData(e.target.value);
                        formik.setFieldValue("f_year", "");
                        setindicatorhodlist([]);
                        formik.handleChange(e);
                      }}
                      style={{ fontWeight: "bold" }}
                      disabled={deptId === "179" || roleid === "8" ? false : true}
                    >
                      <option value="">--Select--</option> {Deptlist}
                    </Field>
                  ) : (
                    <Field className="mb-3 form-control" type="text" name="dept_name" value={localStorage.getItem("SectariatcodeName")} controlId="formBasicEmail" disabled={true} style={{ fontWeight: "bold" }}></Field>
                  )}
                </Col>
  <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3}  > <label className="mb-1 fw-bold">Financial Year</label>
                                         
                <Field className="form-control" component="select" name="f_year" controlId="formBasicEmail" onChange={(e) => {
                  indicatorData(e.target.value);
                                                          //  hoddata(formik.values.department_id,e.target.value); 
                   formik.handleChange(e) }} style={{ fontWeight: "bold" }} > <option value="">--Select--</option>
                    {Yearlist} 
                    {/* <option value="2026-27">2026-27</option>

                    <option value="2025-26">2025-26</option> */}
                    </Field> 

                                          </Col>
                {/* {roleid === "5" || roleid === "8" ? <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className='mandal-select'>
                  <button type="submit" className="btn btn-success mt-4">VIEW DATA</button>
                </Col > : null} */}
              </Row>
            </div>
            {!container &&
            <Row>
              <Col xxl={9} xl={9} lg={9} md={12} sm={12} xs={12} className="">
                <Button variant="danger" size="sm" className="btn mx-2 mt-2 mb-1 pdf-btn" onClick={() => generateentryPdf("my-table", formik.values, "TargetEntry")} style={{ float: "right", marginLeft: "3px" }}>
                  PDF
                  <MdOutlinePictureAsPdf />
                </Button>
                <Button variant="success" size="sm" className="btn mx-2 mt-2 mb-1 excel-btn" style={{ float: "right", color: "#ffffff", marginLeft: "3px" }} onClick={() => exportToentryExcel("my-table", formik.values, "TargetEntry")}>
                  <span style={{ color: "green" }}>
                    Excel
                    <AiFillFileExcel style={{ fontSize: "18px" }} />
                  </span>
                </Button>
                <table className="table table-bordered custom-table table-responsive mt-5" id="my-table">
                  <thead style={{ borderRadius: "10px 10px 0px 0px" }}>
                    <tr className="text-center">
                      <th rowSpan={2}>Sl.No.</th>
                      {/* <th rowSpan={2}>SECTOR</th> */}
                      <th rowSpan={2}>INDICATOR</th>
                      <th rowSpan={2}>UNIT</th>
                      <th colSpan={1}>TARGETS</th>
                    </tr>
                    <tr>
                      <th>{formik.values.f_year}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {indicatorhodlist?.length === 0 || indicatorhodlist?.length === undefined ? (
                      <tr>
                        <td className="text-center" colSpan="4">
                          <b style={{ color: "red" }}>Details Not Found</b>
                        </td>
                      </tr>
                    ) : (
                      (() => {
                        return indicatorhodlist?.map((detail, i) => {
                          return (
                            <tr key={i}>
                              <td style={{ textAlign: "center" }}>{i + 1}</td>
                              <td style={{ textAlign: "left" }}>{(detail.ind_type === "N" && buttonenb && detail.status_id!== 4 ) &&
                                      <img src="../images/new3.gif" width="20px" alt="new" style={{ marginRight: "5px" }} />
                                      }{detail.indicator_name}</td>
                              <td style={{ textAlign: "left" }}>{detail.unit_name}</td>

                              <td className="text-right text-end ">
                              {detail.unit_cat_id !== 13 ? (
                                <Field
                                  autoComplete="off"
                                  className="form-control"
                                  name={`Indicators[${i}].entry_value`}
                                   value={detail.unit_cat_id === 1 ? formatNumberIndianWithDecimal(formik.values.Indicators[i].entry_value) : formik.values.Indicators[i].entry_value}
                                  onBlur={(e) => {
                                    handleInputChange(e, i);
                                    formik.handleChange(e);
                                  }}
                                  // {...restrictToPasteOnlyEightDotThreeAllowKeyPress(formik, "entry_value", i)}
                                  // onKeyPress={(e) => isValidthreee(e)}
                                    onInput={(e) => {
                                                                             if(detail.unit_cat_id === 1){ allowNumberswithMaxLengthcatidtypeOnly(e, maxLen, "numeric", 3); } else{ allowNumberswithMaxLengthtypeOnly(e, maxLen, "numeric", 3) } } }
                                                                                                          {...detail.unit_cat_id === 1 ? restrictToPasteOnlyEightDotcommaThreeAllowKeyPress( formik, "entry_value", i ) :restrictToPasteOnlyEightDotThreeAllowKeyPress( formik, "entry_value", i)}
                                  type="text"
                                  style={{ textAlign: "right" }}
                                 disabled={formik.values.Indicators[i]?.status_id === 4}
                                />
                                ) : (
                                            <Field
                                              component="select"
                                              name={`Indicators[${i}].entry_value`}
                                              className="form-control mb-3"
                                              style={{ fontWeight: "bold" }}
                                          disabled={formik.values.Indicators[i]?.status_id === 4}
                                              
                                            >
                                              <option value="">--Select--</option>
                                              <option value="100">TOP ACHIEVERS</option>
                                              <option value="75">ACHIEVERS</option>
                                              <option value="50">FAST MOVERS</option>
                                              <option value="25">ASPIRERS</option>
                                            </Field>
                                          )}
                              </td>
                            </tr>
                          );
                        });
                      })()
                    )}
                  </tbody>
                </table>
                <div className="bottom-buttons d-flex justify-content-center mt-4 mb-5">
                  {buttonenb && (
                    <>
                      <Button variant="" size="sm" className="save-btn me-4" type="button" onClick={() => SaveEntryData("District")}>
                        Save <FaRegSave className="ms-1 s-icon" />
                      </Button>
                      {roleid !== "8" && (
                        <Button
                          variant=""
                          size="sm"
                          className="next-btn me-4"
                          type="button"
                          onClick={() => {
                            updateData();
                          }}
                        >
                          Submit&Freeze <FaRegSave className="ms-1 s-icon" />
                        </Button>
                      )}
                    </>
                  )}
                </div>
              </Col>
            </Row>}
            {container && ( <>
         
         
            <Row className="w-100 justify-content-center mt-4 mb-3"> <Col xxl={8} xl={8} lg={8} md={10} sm={10} xs={12}> <Alert severity="warning" icon={<FaExclamationTriangle className="blinking-icon" />} sx={{ fontSize: "16px", padding: "40px 32px", borderRadius: "8px", backgroundColor: "#fff3cd", color: "#856404", boxShadow: "0 2px 6px rgba(0,0,0,0.1)", }} >
            Secretariat Level Indicators Not Available </Alert> </Col> </Row> 
            </> )} 
          </Form>
        </FormikProvider>
      </Container>
      <Modal fade={false} className="newmodal" aria-labelledby="contained-modal-title-vcenter" centered show={showModal} onHide={null} backdrop="static" keyboard={false}>
        <Modal.Header>
          <Modal.Title></Modal.Title>
          <button onClick={handleClose} onMouseEnter={(e) => (e.currentTarget.style.color = "red")} onMouseLeave={(e) => (e.currentTarget.style.color = "white")} style={{ fontSize: "30px", cursor: "pointer", background: "none", border: "none", color: "white" }} className="me-1" aria-label="Close">
            &#215;
          </button>
        </Modal.Header>

        <Modal.Body className="p-3 d-flex flex-column justify-content-center align-items-center" onKeyDown={handleKeyDown}>
          <div className="text-center">
            <img src="images/question.gif" style={{ width: "70px", marginBottom: "10px" }} alt="Warning Icon" />
            <p className="fw-bold" style={{ fontSize: "17px" }}>
              Are you sure you want to Proceed Once Submitted No More Changes Can be Done?
            </p>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <button type="button" className="conform" onClick={handleConfirm}>
            Yes
          </button>
          <button type="button" className="cancel" onClick={handleClose}>
            No
          </button>
        </Modal.Footer>
      </Modal>
      <AlertModal show={showAlert} titleText={alertData.titleText} alertText={alertData.alertText} onClose={closeAlert} />
    </>
  );
}
